import withReduxForm from '../withReduxForm'
import Option from './Option'
import { ISelectInputProps, SelectInput } from './Select'
import { CreatableSelectInput, ICreatableSelectProps } from './CreatableSelect'
import withRedux from './withRedux'

const CreatableSelectInputRedux = withReduxForm<ICreatableSelectProps>(
  withRedux(CreatableSelectInput),
)

export default withReduxForm<ISelectInputProps>(withRedux(SelectInput))
export { SelectInput, Option, CreatableSelectInput, CreatableSelectInputRedux }
